/* unplugin-vue-components disabled */import { render } from "./SendEmail.vue?vue&type=template&id=6a5a5f38&scoped=true&ts=true"
import script from "./SendEmail.vue?vue&type=script&lang=ts"
export * from "./SendEmail.vue?vue&type=script&lang=ts"

import "./SendEmail.vue?vue&type=style&index=0&id=6a5a5f38&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5a5f38"]])

export default __exports__